export const MY_POINTS_LIST = 'MY_POINTS_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-points/store/mutations-types.js